<template>
  <div class="h-full w-full relative">
    <div class="absolute inset-0 m-4 overflow-hidden">
      <div class="h-full w-full bg-white flex rounded-lg">
        <div class="w-1/4 box-border border-r-2 h-full overflow-y-auto">
          <div class="p-4">
            <router-link
              to="/corporate/add"
              class="inline-block w-full text-center py-2 bg-ilift-500 text-ilift-900 rounded font-semibold hover:bg-ilift-600 shadow"
            >
              Add Corporate
            </router-link>
          </div>
          <!--  -->
          <div class="px-4 py-2 border-t">
            <input
              type="text"
              v-model="searchKey"
              class="form-input w-full"
              placeholder="Search..."
            />
          </div>
          <div
            v-for="(corporate, index) in corporates"
            :key="corporate._id"
            @click="selectCorporate(index)"
            class="flex items-center space-x-4 px-4 py-2 border-t border-b mb-1 hover:bg-gray-200 cursor-pointer"
            :class="
              selectedCorporate && corporate._id === selectedCorporate._id
                ? 'bg-gray-200'
                : ''
            "
          >
            <div class="h-12 w-12 rounded bg-teal-500"></div>
            <div>
              <h1 class="text-xl">{{ corporate.name }}</h1>
              <p class="text-gray-700 text-sm">{{ corporate.email }}</p>
            </div>
          </div>
          <!--  -->
        </div>
        <div class="w-3/4 overflow-y-auto">
          <div v-if="selectedCorporate !== null">
            <div class="w-full bg-ilift-500 py-2 px-4">
              <strong>{{ selectedCorporate.name }}</strong>

              <!-- Rounded switch -->
              <label class="switch float-right">
                <input
                  type="checkbox"
                  @change="updateState"
                  v-model="selectedCorporate.active"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <ul class="flex border-b">
              <li
                v-bind:class="[
                  selectedTab == 'profile' ? '-mb-px mr-1' : 'mr-1'
                ]"
                @click="selectTab('profile')"
              >
                <span
                  v-bind:class="[
                    selectedTab == 'profile'
                      ? 'bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 text-blue-700 font-semibold'
                      : 'bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold'
                  ]"
                  >Profile</span
                >
              </li>
              <li
                v-bind:class="[selectedTab == 'rides' ? '-mb-px mr-1' : 'mr-1']"
                @click="selectTab('rides')"
              >
                <span
                  v-bind:class="[
                    selectedTab == 'rides'
                      ? 'bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 text-blue-700 font-semibold'
                      : 'bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold'
                  ]"
                  >Rides</span
                >
              </li>
              <li
                v-bind:class="[
                  selectedTab == 'tickets' ? '-mb-px mr-1' : 'mr-1'
                ]"
                @click="selectTab('tickets')"
              >
                <span
                  v-bind:class="[
                    selectedTab == 'tickets'
                      ? 'bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 text-blue-700 font-semibold'
                      : 'bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold'
                  ]"
                  >Tickets</span
                >
              </li>
              <li
                v-bind:class="[
                  selectedTab == 'accounts' ? '-mb-px mr-1' : 'mr-1'
                ]"
                @click="selectTab('accounts')"
              >
                <span
                  v-bind:class="[
                    selectedTab == 'accounts'
                      ? 'bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 text-blue-700 font-semibold'
                      : 'bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold'
                  ]"
                  >Accounts</span
                >
              </li>
              <li></li>
            </ul>
            <div class="p-4">
              <Profile
                v-if="selectedTab == 'profile'"
                :corporate="selectedCorporate"
              ></Profile>
              <Rides
                v-if="selectedTab == 'rides'"
                :corporate="selectedCorporate"
              ></Rides>
              <Tickets
                v-if="selectedTab == 'tickets'"
                :corporate="selectedCorporate"
              ></Tickets>
              <Accounts
                v-if="selectedTab == 'accounts'"
                :corporate="selectedCorporate"
              ></Accounts>
            </div>
          </div>
          <div v-else>
            <h3 class="font-semibold text-gray-700 text-xl p-4">
              Select a corporate from the list on the left!
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rides from "@/views/Corporate/Rides";
import Profile from "@/views/Corporate/Profile";
import Tickets from "@/views/Corporate/Tickets";
import Accounts from "@/views/Corporate/Accounts/Accounts";
export default {
  components: {
    Rides,
    Profile,
    Tickets,
    Accounts
  },
  data() {
    return {
      corporates: [],
      selectedCorporate: null,
      selectedTab: "profile",
      loading: false,
      searchKey: ""
    };
  },
  watch: {
    selectedCorporate() {},
    searchKey() {
      this.getCorporates();
    }
  },
  created() {
    this.getCorporates();
  },
  methods: {
    getCorporates() {
      this.$http
        .get("/corporates?q=" + this.searchKey)
        .then(response => (this.corporates = response.data.data))
        .catch(err => console.log(err));
    },
    selectCorporate(index) {
      this.selectedCorporate = this.corporates[index];
    },
    updateState() {
      this.$http
        .patch("/corporates/" + this.selectedCorporate._id, {
          active: this.selectedCorporate.active
        })
        .then(response => console.log(response))
        .catch(err => console.log(err));
    },
    selectTab(tab) {
      this.selectedTab = tab;
    }
  }
};
</script>

<style lang="scss" scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 25px;
  width: 25px;
  left: 0px;
  bottom: 0px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>